// extracted by mini-css-extract-plugin
export default {"cardCtaLink":"lib-component-mappings-sky-parallax-components-ProductHeroCTAs-CardCta__cardCtaLink--_eRSn"};